


























import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import CreditCardForm from '../../components/CreditCardForm.vue';
import ACHAccountForm from '../../components/ACHAccountForm.vue';
import MessageBox from '../../components/MessageBox.vue';
import { CreditCard, MemberProfileRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { CommonUtils } from '../../util/commonUtils';
@Component({
    props: {
        memberRequest: Object,
    },
    data() {
        return {
            method: 'CC',
        };
    },
    components: {
        CreditCardForm,
        ACHAccountForm,
        MessageBox,
    },
})
export default class PaymentInformation extends Vue {

    private isPaymentSourceValid: boolean = false;
    private disableSave = false;
    private messageBoxData = {
        message: CommonUtils.translateMessageCode('MSG_ACCOUNT_SETUP'),
        title: 'Congratulations!',
    };
    public mounted() {
        if (this.$props.memberRequest.memberType === 'ORG_MANAGER') {
            if (!this.$props.memberRequest.subscriptionPlan) {
                this.$router.push({ name: MedTransGoConstants.VIEW_SUBSCRIPTION_PLANS_NAME });
            }
        }
        this.$props.memberRequest.paymentSource = '';
    }

    private gotoPreviousStep() {
        if (this.$props.memberRequest.memberType === 'ORG_MANAGER') {
            this.$router.push({ name: MedTransGoConstants.VIEW_SUBSCRIPTION_PLANS_NAME });
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_MEMBER_TYPE_NAME });
        }
    }

    private saveCreditCard(creditCard: CreditCard) {
        this.isPaymentSourceValid = (creditCard.cardHolderName && creditCard.cardToken);
        if (this.isPaymentSourceValid) {
            this.$props.memberRequest.paymentSource = creditCard.cardToken.token.id;
        } else {
            this.$props.memberRequest.paymentSource = '';
        }
    }

    private saveAchAccount(paymentSource: string) {
        this.isPaymentSourceValid = paymentSource.length > 5;
        this.$props.memberRequest.paymentSource = paymentSource;
    }

    private async completeRegistration() {
        const iCacheService = ObjectFactory.getCacheService();
        const sessionData = iCacheService.getSessionInfo();
        let requestData: MemberProfileRequest = JSON.parse(JSON.stringify(this.$props.memberRequest));
        requestData.userId = sessionData.id;
        delete requestData.organizationValid;
        requestData.referralSource = `${requestData.sourceAnswer}-${requestData.sourceDetailsAnswer}`;
        delete requestData.sourceAnswer;
        delete requestData.sourceDetailsAnswer;
        delete requestData.sourceDetailsQuestion;
        if (requestData.memberType === 'INDIVIDUAL') {
            requestData = {
                memberType: 'INDIVIDUAL',
                paymentSource: requestData.paymentSource,
                userId: requestData.userId,
                subscriptionPlan: requestData.subscriptionPlan,
            };
        }
        this.disableSave = true;
        if (requestData.isCaseManager) {
            this.messageBoxData.title = 'Thank You!',
            this.messageBoxData.message = CommonUtils.translateMessageCode('MSG_COMP_REGISTRATION');
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
        }
        const apiResponse = await ObjectFactory.getMemberService().
            saveMemberProfile(this.$store.state.serverUrl, requestData);
        if (apiResponse.success) {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
        } else {
            CommonUtils.showError(apiResponse);
            if (apiResponse.errorCode === 'USER_ALREADY_EXISTS') {
                this.messageBoxData.title = 'Already Registered!';
                this.messageBoxData.message = CommonUtils.translateMessageCode('MSG_COMPLETE_REGISTRATION');
                const messageBox: any = this.$refs.messageBox;
                messageBox.showModal();
            }
        }
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
